export default [
  {
    path: '/smart-reporting/quarterly-kpi-report',
    name: 'see-smartReports-mediaReports-quarterlyKpiReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/quarterly-kpi-report/Index.vue')
  },
  {
    path: '/smart-reporting/comparison-report',
    name: 'see-smartReports-mediaReports-comparisonReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/comparison-report/Index.vue')
  },
  {
    path: '/smart-reporting/placement-report',
    name: 'see-smartReports-mediaReports-placementReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/placement-report/Index.vue')
  },
  {
    path: '/smart-reporting/product-report',
    name: 'see-smartReports-mediaReports-ecommerceProductReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/product-report/Index.vue')
  },
  {
    path: '/smart-reporting/audience-report',
    name: 'see-smartReports-mediaReports-audienceReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/audience-report/Index.vue')
  },
  {
    path: '/smart-reporting/channel-report',
    name: 'see-smartReports-mediaReports-channelReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/media-planner-live/Index.vue')
  },
  // make this page parent if possible
  {
    path: '/smart-reporting',
    name: 'see-smartReports-mediaReports',
    component: () => import('@/views/see/smart-reporting/custom-reports/Index.vue')
  },
  {
    path: '/smart-reporting/campaign-performance-report',
    name: 'see-smartReports-mediaReports-campaignPerformanceReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/campaign-performance-report/Index.vue')
  },
  {
    path: '/smart-reporting/budget-tracking-report',
    name: 'see-smartReports-mediaReports-budgetTrackingReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/budget-tracking-report/Index.vue'),
  },
  {
    path: '/smart-reporting/budget-report',
    name: 'see-smartReports-mediaReports-budgetReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/budget-report/Index.vue')
  },
  {
    path: '/smart-reporting/performance-report',
    name: 'see-smartReports-mediaReports-performanceReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/performance-report/Index.vue')
  },
  {
    path: '/smart-reporting/daily-report',
    name: 'see-smartReports-mediaReports-dailyReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/daily-report/Index.vue')
  },
  {
    path: '/smart-reporting/brand-summary-report',
    name: 'see-smartReports-mediaReports-brandSummaryReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/brand-summary-report/Index.vue')
  },
  {
    path: '/smart-reporting/ydpt-report',
    name: 'see-smartReports-mediaReports-ydptReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/ydpt-report/Index.vue')
  },
  {
    path: '/smart-reporting/adjust-campaign-report',
    name: 'see-smartReports-mediaReports-adjustCampaignReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/adjust-campaign-report/Index.vue')
  },
  {
    path: '/smart-reporting/kpi-tracking-report',
    name: 'see-smartReports-mediaReports-kpiTrackingReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/kpi-tracking-report/Index.vue'),
  },
  {
    path: '/smart-reporting/lead-report',
    name: 'see-smartReports-mediaReports-leadReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/lead-report/Index.vue'),
  },
  {
    path: '/smart-reporting/budget-tracking-report',
    name: 'see-smartReports-mediaReports-budgetTrackingReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/budget-tracking-report/Index.vue'),
  },
  {
    path: '/smart-reporting/seo-monitor-report',
    name: 'see-smartReports-mediaReports-seoMonitorReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/seo-monitor-report/Index.vue'),
  },
  {
    path: '/smart-reporting/creative-report',
    name: 'see-smartReports-mediaReports-creativeReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/papara-creative-report/Index.vue'),
  },
  {
    path: '/smart-reporting/awareness-report',
    name: 'see-smartReports-mediaReports-awarenessReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/awareness-report/Index.vue'),
  },
  {
    path: '/smart-reporting/plan-summary-report',
    name: 'see-smartReports-mediaReports-planSummaryReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/plan-summary-report/Index.vue'),
  },
  {
    path: '/smart-reporting/papara-performance-report',
    name: 'see-smartReports-mediaReports-paparaPerformanceReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/papara-perf-report/PaparaPerfReport.vue'),
    children: [
      {
        path: 'overview',
        name: 'see-smartReports-mediaReports-paparaPerformanceReport-overview',
        component: () => import('@/views/see/smart-reporting/custom-reports/papara-perf-report/overview/Index.vue')
      },
      {
        path: 'product',
        name: 'see-smartReports-mediaReports-paparaPerformanceReport-product',
        component: () => import('@/views/see/smart-reporting/custom-reports/papara-perf-report/product/Index.vue')
      },
      {
        path: 'campaign',
        name: 'see-smartReports-mediaReports-paparaPerformanceReport-campaign',
        component: () => import('@/views/see/smart-reporting/custom-reports/papara-perf-report/event/Index.vue')
      },
    ]
  },
  {
    path: '/smart-reporting/always-on-campaign-report',
    name: 'see-smartReports-mediaReports-alwaysOnCampaignReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/always-on-campaign-report/AlwaysOnCampaignReport.vue'),
    children: [
      {
        path: 'group',
        name: 'see-smartReports-mediaReports-alwaysOnCampaignReport-group',
        component: () => import('@/views/see/smart-reporting/custom-reports/always-on-campaign-report/group/Index.vue')
      },
      {
        path: 'fraud',
        name: 'see-smartReports-mediaReports-alwaysOnCampaignReport-fraud',
        component: () => import('@/views/see/smart-reporting/custom-reports/always-on-campaign-report/fraud/Index.vue')
      },
    ]
  },
  {
    path: '/smart-reporting/retailer-and-product-report',
    name: 'see-smartReports-mediaReports-retailerAndProductReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/retailer-and-product-report/ReportNav.vue'),
    children: [
      {
        path: 'summary',
        name: 'see-smartReports-mediaReports-retailerAndProductReport-summary',
        component: () => import('@/views/see/smart-reporting/custom-reports/retailer-and-product-report/summary/Index.vue')
      },
      {
        path: 'retailer-platform-by-brand',
        name: 'see-smartReports-mediaReports-retailerAndProductReport-retailerPlatformByBrand',
        component: () => import('@/views/see/smart-reporting/custom-reports/retailer-and-product-report/retail-platform-by-brand/Index.vue')
      },
    ]
  },
  {
    path: '/smart-reporting/collaborative-report',
    name: 'see-smartReports-mediaReports-collaborativeReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/collaborative-report/Index.vue'),
  },
  {
    path: '/smart-reporting/all-funnel-report',
    name: 'see-smartReports-mediaReports-allFunnelReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/ldb-all-campaigns-tracking-report/Index.vue'),
  },
  {
    path: '/smart-reporting/poc-report',
    name: 'see-smartReports-mediaReports-pocReport',
    component: () => import('@/views/see/smart-reporting/custom-reports/poc-report/PocReport.vue'),
    children: [
      {
        path: 'overview',
        name: 'see-smartReports-mediaReports-pocReport-overview',
        component: () => import('@/views/see/smart-reporting/custom-reports/poc-report/overview/Index.vue')
      },
      {
        path: 'results',
        name: 'see-smartReports-mediaReports-pocReport-results',
        component: () => import('@/views/see/smart-reporting/custom-reports/poc-report/results/Index.vue')
      },
    ]
  },
  // {
  //   path: '/seo',
  //   name: 'seoPage',
  //   component: () => import('@/views/see/smart-reporting/seo/Seo.vue'),
  //   children: [
  //     {
  //       path: 'overview',
  //       name: 'seo-overview',
  //       component: () => import('@/views/see/smart-reporting/seo/overview/Index.vue')
  //     },
  //     {
  //       path: 'organic-traffic',
  //       name: 'seo-organicTraffic',
  //       component: () => import('@/views/see/smart-reporting/seo/organic-traffic/Index.vue')
  //     },
  //     {
  //       path: 'engagement-behavior',
  //       name: 'seo-engagementBehavior',
  //       component: () => import('@/views/see/smart-reporting/seo/engagement-behavior/Index.vue')
  //     },
  //     {
  //       path: 'goals',
  //       name: 'seo-goals',
  //       component: () => import('@/views/see/smart-reporting/seo/goals/Index.vue')
  //     },
  //     {
  //       path: 'competitors',
  //       name: 'seo-competitors',
  //       component: () => import('@/views/see/smart-reporting/seo/competitors/Index.vue')
  //     },
  //     {
  //       path: 'outreach-performance',
  //       name: 'seo-outreachPerformance',
  //       component: () => import('@/views/see/smart-reporting/seo/outreach-performance/Index.vue')
  //     },
  //     {
  //       path: 'comparison',
  //       name: 'seo-comparison',
  //       component: () => import('@/views/see/smart-reporting/seo/comparison/Index.vue')
  //     },

  //   ]
  // },
]
